// extracted by mini-css-extract-plugin
export var headline = "i-Cbr";